import * as React from 'react';
import { EventRowMLB } from './eventRowMLB/EventRowMLB';
import { EventRowNBA } from './eventRowNBA/EventRowNBA';
import { EventRowNFL } from './eventRowNFL/EventRowNFL';
import { EventRowNHL } from './eventRowNHL/EventRowNHL';
import { checkCompetition } from 'src/domains/sportsbook/utils/checkCompetition';
import { EventListGroupEventItemType } from 'src_common/common/websocket2/modelsApi/EventsCollectionQuery';

export interface AmericanLeagueRowFlagsType {
    readonly isMLBorMajorCompetition: boolean;
    readonly isNHL: boolean;
    readonly isNBA: boolean;
    readonly isNFL: boolean;
}

export function getAmericanLeagueRowFlags(competitionName: string, sport: string): AmericanLeagueRowFlagsType {
    return {
        isMLBorMajorCompetition: checkCompetition(competitionName, ['MLB', 'Major']) && sport === 'baseball',
        isNHL: checkCompetition(competitionName, ['NHL']),
        isNBA: checkCompetition(competitionName, ['NBA']),
        isNFL: competitionName === 'US NFL' || competitionName === 'NFL Matches',
    };
}

export function renderAmericanLeagueEventRowIfApplicable(
    event: EventListGroupEventItemType,
    flags: AmericanLeagueRowFlagsType,
    keyPrefix: string
): React.ReactElement | null {
    const isTwoParticipant = event.template.startsWith('two-participant');
    const key = `${keyPrefix}_${event.id}`;

    if (flags.isMLBorMajorCompetition && isTwoParticipant) {
        return (
            <EventRowMLB
                key={key}
                eventId={event.id2}
                smallEvent={event}
            />
        );
    }
    if (flags.isNHL && isTwoParticipant) {
        return (
            <EventRowNHL
                key={key}
                eventId={event.id2}
                smallEvent={event}
            />
        );
    }
    if (flags.isNBA && isTwoParticipant) {
        return (
            <EventRowNBA
                key={key}
                eventId={event.id2}
                smallEvent={event}
            />
        );
    }
    if (flags.isNFL) {
        return (
            <EventRowNFL
                key={key}
                eventId={event.id2}
                smallEvent={event}
            />
        );
    }

    return null;
}
